<template>
  <div class="orders-sort-by-status">
    <p class="orders-sort-by-status__title">
      {{ $t('orders.status') }}
    </p>
    <div class="orders-sort-by-status__select-wrapper">
      <AtSelect
          class="orders-sort-by-status__select"
          :placeholder="select_the_status"
          clearable
          :value="isActiveStatus"
          @on-change="selectStatus"
      >
        <AtOption
            v-for="(status, key) in $options.statuses"
            :key="key"
            :value="status.value"
            :label="$t(status.title)"
        />

      </AtSelect>
      <p class="orders-sort-by-status__status">{{ selectedStatus }}</p>
    </div>

  </div>
</template>

<script>

import {mapState, mapMutations, mapActions} from 'vuex';

import AtSelect from 'at-ui/src/components/select';
import AtOption from 'at-ui/src/components/option';
import {ORDER_STATUS_ENUM} from "../../../../common/constants/orders-status-enum";

export default {
    name: 'OrdersSortByStatus',
    statuses: [
        {
            value: ORDER_STATUS_ENUM.INIT,
            title: 'orders.active',
        },
        {
            value: ORDER_STATUS_ENUM.PENDING,
            title: 'orders.in_processing',
        },
        {
            value: ORDER_STATUS_ENUM.PARTIAL,
            title: 'orders.partial_payment',
        },
        {
            value: ORDER_STATUS_ENUM.PROCESSED,
            title: 'orders.completed',
        },
        {
            value: ORDER_STATUS_ENUM.EXPIRED,
            title: 'orders.expired',
        },
        {
            value: ORDER_STATUS_ENUM.ERROR,
            title: 'orders.with_errors',
        },
    ],
    components: {
        AtSelect,
        AtOption,
    },
    computed: {
        ...mapState('orders', {
            isActiveStatus: state => state.filters.status[0],
        }),
        select_the_status() {
            return this.$t('orders.select_the_status');
        },
        selectedStatus() {
            const status = this.$options.statuses.find((status) => {
                return status.value === this.isActiveStatus;
            });
            return this.$t(status?.title);
        },
    },
    beforeMount() {
        this.clearFilters();
        this.setStatusFromUrl();
    },
    methods: {
        ...mapMutations('orders', [
            'filtersStatus',
            'clearFilters',
        ]),
        ...mapActions('orders', [
            'fetchOrders',
        ]),
        setStatusFromUrl() {
            const {
                $route: {query},
                filtersStatus,
            } = this;
            const statusFromUrl = query.status;

            if (!statusFromUrl) {
                return false;
            }

            filtersStatus(statusFromUrl.split(','));
        },
        selectStatus(values) {
            const {
                $route,
                $router,
                filtersStatus,
                fetchOrders,
            } = this;
            const val = values ? [values] : [];
            filtersStatus(val);
            fetchOrders({
                route: $route,
                router: $router,
                excludeParams: ['page'],
            });
        },
    },
};

</script>

<style lang="scss" scoped>

.orders-sort-by-status {
  width: 100%;
  &__title {
    margin-bottom: 8px;
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
  }

  &__select ::v-deep .at-select__selection {
    min-height: 28px;
    border: 1px solid var(--border-color);
    background: var(--secondary-color);
    color: var(--primary-font-color);
  }

  &::v-deep .at-select__dropdown {
    border: 1px solid var(--border-color);
    background: var(--bg-select);
  }

  ::v-deep .at-select__option--selected {
    background: var(--hover-color-select);
  }

  &::v-deep .at-select__dropdown .at-select__option {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);

    &:hover {
      background: var(--hover-color-select);
    }
  }

  ::v-deep .at-select__placeholder {
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
  }

  ::v-deep .at-select__selected {
    display: none;
  }

  &__select-wrapper {
    position: relative;
  }

  &__status {
    position: absolute;
    top: 12px;
    left: 30px;
    font-family: var(--font-family);
    font-size: var(--font-size-text-main);
    line-height: var(--line-height);
    color: var(--primary-font-color);
    pointer-events: none;
  }


}


</style>
